export * from './:id'
